import { Country } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from "../../Business/dto/ExternalSystemElement";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface CountryPickerProps {
    setSelectedCountry: (country: Country) => void;
    required?: boolean;
    value: Country | undefined;
}

export const CountryPicker = (props: CountryPickerProps) => {
    const { t } = useTranslation();
    
    return (
        <>
                <ExternalDataPicker
                    setSelectedData={props.setSelectedCountry}
                    placeholder={t("txt_country_label")}
                    dataKey={DataKey.Country}
                    icon={faGlobe}
                    required={props.required}
                    controlId="countryPicker"
                    value={props.value ? [props.value] : []}
                />
        </>
    );
}